{
  "pays": "Sénégal",
  "capital": "Dakar",
  "langueOfficielle": "Français",
  "languesNationales": ["Wolof", "Pular", "Sérère", "Diola", "Mandingue", "Soninké", "Bambara"],
  "monnaie": "Franc CFA",
  "devise": "Un Peuple, Un But, Une Foi",
  "drapeau": "https://cdn.countryflags.com/thumbs/senegal/flag-400.png",
  "codeIso": "SN",
  "indicatif": 221,
  "habitants": 18126390,
  "surface": 196712,
  "regions": 14,
  "departments": 46
}
